import { getDate } from "date-fns";

/**
 * Gets the current date of the month
 */
export default function(date: number | Date)
{
    return getDate(date);
}